import { Image } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { AgnosticMediaGalleryItem } from '@vue-storefront/core';

export const imagesAgnosticBuilder = (
  images: Image[]
): AgnosticMediaGalleryItem[] => {
  const agnosticImagesConfig: any = images.reduce((results, currentValue) => {
    if (!results[currentValue.galleryIndex]) {
      results[currentValue.galleryIndex] = {};
    }
    if (currentValue.format === 'thumbnail') {
      results[currentValue.galleryIndex].small = currentValue.url;
    }

    if (currentValue.format === 'product') {
      results[currentValue.galleryIndex].normal = currentValue.url;
    }

    if (currentValue.format === 'zoom') {
      results[currentValue.galleryIndex].big = currentValue.url;
    }
    return results;
  }, {});
  return Object.values(agnosticImagesConfig);
};
